__turbopack_context__.v({
  "chipGroup": "kEoDqa_chipGroup",
  "filtersWrapper": "kEoDqa_filtersWrapper",
  "iconWrapper": "kEoDqa_iconWrapper",
  "label": "kEoDqa_label",
});
